<app-protected-content [requiredRoles]="requiredRoles" [requireApprovedOrganization]="true">
  <div class="container" *transloco="let t; prefix 'partnernetwork.detail'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">
      {{ 'button.back' | transloco }}
    </htx-button>

    <div class="panel">
      <div class="header-section">
        <div class="header-title-section">
          <h1 class="header-title">{{ 'partnernetwork.detail.header' | transloco }}</h1>
          <p class="header-subtitle">{{ 'partnernetwork.detail.sub-header' | transloco }}</p>
        </div>
      </div>

      @let details = organizationDetails$ | async;
      @if (details) {
        <htx-data-display
          [title]="t('organizationDetails')"
          [icon]="'business'"
          [data]="details"></htx-data-display>
      }
    </div>
  </div>

  <ng-template #activityStateTemplate>
    <htx-badge
      [text]="'organization.control.activityState.options.' + activityState | transloco"
      [variant]="activityState === 'ACTIVE' ? 'success' : 'danger'">
    </htx-badge>
  </ng-template>

  <ng-template #didTemplate>
    <htx-badge [text]="did || '-'" variant="tertiary"></htx-badge>
  </ng-template>
</app-protected-content>
